import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import { Theme } from "./Theme";
import DocumentInternals from "./DocumentInternals";
import { DocumentProvider } from "./DocumentProvider";

const Document = props => {
  return ___EmotionJSX(Theme, null, ___EmotionJSX(DocumentProvider, null, ___EmotionJSX(DocumentInternals, null, props.children)));
};

export default Document;